module.exports = (__parcel__import__("./" + require('./helpers/bundle-manifest').resolve("b0G1F"))).then(() => parcelRequire('jjPaC'));